import { VFC } from "react";
import { DieLigen } from "./dieLigen/DieLigen";
import { ModalProvider } from '../../../features/modalProvider';
import { _ } from "i18n";

interface ApiManagementProps {
	activeMenu: string;
}

export const ApiManagement: VFC<ApiManagementProps> = ({ activeMenu }) => {
	const renderContent = () => {
		switch (activeMenu) {
			case "die_ligen":
				return <DieLigen />;
			default:
				return <div>No available API section</div>;
		}
	};

	return (
		<ModalProvider>
			<div className="api-management-container">
				{renderContent()}
			</div>
		</ModalProvider>
	);
};
